<template>
  <div>
    <el-button class="newAdd" @click="openDialog" size="mini"
      >添加合伙人</el-button
    >
    <el-dialog
      title="添加合伙人"
      :visible.sync="moveDialogVisible"
      width="40%"
      center
      @close="clear"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="UID" :label-width="formLabelWidth" prop="userId">
          <div class="search">
            <el-input
              v-model="form.userId"
              class="searchIpt"
              autocomplete="off"
            ></el-input>
            <el-button size="mini" @click="searchById">查询</el-button>
          </div>
        </el-form-item>
        <el-form-item label="" :label-width="formLabelWidth" v-if="isAct">
          <div>查询信息</div>
          <div>用户UID: {{ detailInfo ? detailInfo.id : "" }}</div>
          <div>
            邮箱：{{ detailInfo ? detailInfo.email || detailInfo.tel : "" }}
          </div>
          <div>
            注册时间：
            {{ detailInfo ? transferTime(detailInfo.createTime) : "" }}
          </div>
        </el-form-item>
        <el-form-item
          label="邀请人UID"
          :label-width="formLabelWidth"
          prop="inviteBy"
        >
          <el-input
            v-model="form.inviteBy"
            class="searchIpt"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="合约返佣比例"
          :label-width="formLabelWidth"
          prop="rate"
        >
          <el-input
            v-model="form.rate"
            class="searchIpt"
            maxlength="3"
            autocomplete="off"
            @input="(val) => handleIntegerInput('rate', val)"
          >
            <template slot="append">%</template></el-input
          >
        </el-form-item>
        <el-form-item
          label="现货返佣比例"
          :label-width="formLabelWidth"
          prop="spotRate"
        >
          <el-input
            v-model="form.spotRate"
            class="searchIpt"
            maxlength="3"
            autocomplete="off"
            @input="(val) => handleIntegerInput('spotRate', val)"
          >
            <template slot="append">%</template></el-input
          >
        </el-form-item>
        <!-- <el-form-item
          label="otc返佣比例"
          :label-width="formLabelWidth"
          prop="otcRate"
        >
          <el-input v-model="form.otcRate" class="searchIpt" autocomplete="off">
            <template slot="append">%</template></el-input
          >
        </el-form-item> -->
        <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
          <el-input
            v-model="form.remark"
            class="searchIpt"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="add">添加</el-button>
        <el-button size="mini" @click="clearFiled">重置</el-button>
      </span>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

const validateInteger = (requiredMessage) => (rule, value, callback) => {
  if (value === "" || value === null || value === undefined) {
    if (requiredMessage) {
      callback(new Error(requiredMessage));
    } else {
      callback();
    }
    return;
  }
  if (!/^\d+$/.test(String(value).trim())) {
    callback(new Error("只能输入整数"));
    return;
  }
  callback();
};

export default {
  data() {
    return {
      moveDialogVisible: false,
      detailInfo: null,
      isAct: false,
      form: {
        inviteBy: "",
        userId: "",
        rate: "",
        remark: "",
        spotRate: "",
      },
      formLabelWidth: "140px",
      rules: {
        userId: [{ required: true, message: "请输入UID", trigger: "blur" }],
        inviteBy: [
          { required: true, message: "请输入合伙人UID", trigger: "blur" },
        ],
        rate: [
          {
            required: true,
            validator: validateInteger("请输入比例"),
            trigger: "blur",
          },
        ],
        spotRate: [{ validator: validateInteger(), trigger: "blur" }],
        otcRate: [
          { required: true, message: "请输入otcRate返佣比例", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    ...mapActions("partnerList", ["addPartner", "getUserData"]),
    transferTime(time) {
      var date = new Date(time);
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      var time1 = Y + M + D + h + m;
      return time1;
    },
    openDialog() {
      this.moveDialogVisible = true;
    },
    handleIntegerInput(field, val) {
      this.form[field] = String(val).replace(/\D/g, "");
    },
    searchById() {
      if (this.form.userId == "" || this.form.userId == null) {
        this.$message.warning("请输入UID");
      } else {
        this.getUserData({ userId: this.form.userId }).then((res) => {
          console.log("getUserData", res);
          if (res.code == 0) {
            this.isAct = true;
            this.detailInfo = { ...res.data };
          } else {
            this.isAct = false;
          }
        });
      }
    },
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.addPartner(this.form).then((res) => {
            if (res.code == 0) {
              this.$message.success("添加成功");
              this.$emit("refresh");
              this.clear();
            } else {
              this.$message.error("添加失败");
              this.clear();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    clearFiled() {
      this.$refs["form"].resetFields();
    },
    clear() {
      this.moveDialogVisible = false;
      this.$refs["form"].resetFields();
    },
  },
};
</script>

<style lang="less" src="../../../../styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;
  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }
  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    .ipt {
      width: 90%;
    }
  }
}
.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
